import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { yupSchemaStep5 } from "schemas/yupSchema";
import { requestJson, RequestMethod } from "helpers/httpHelper";
import { prepareDataStep5, prepareDataStep5_STRAIN } from "helpers/PrepareData";
import { goToTop, refToErrorFormik } from "helpers/helpers";
import { toast } from "react-toastify";
import Step5CetatenieRoman from "components/Step5/Step5CetatenieRoman";
import Step5CetatenieStrain from "components/Step5/Step5CetatenieStrain";
import ProgressBar from "react-bootstrap/ProgressBar";
import NavigateButtons from "components/NavigateButtons";

export default function Step5({ currentStep, setCurrentStep, stepsState, persistState, tipCetatenie }) {
   const [progress, setProgress] = useState(10);
   const [showProgressBar, setShowProgressBar] = useState(false);

   const headerText = tipCetatenie === "ROMAN" ? "a actului" : "al actelor";

   const formik = useFormik({
      enableReinitialize: true,
      initialValues: stepsState.step5,
      validationSchema: yupSchemaStep5,
      onSubmit: values => {
         startProgressBar();
         goToTop();
         saveData(values);
      },
   });

   const saveData = async values => {
      setShowProgressBar(true);
      var opportunityId = stepsState.opportunityId;
      if (opportunityId === undefined || opportunityId === null) {
         console.log('opportunityId is undefined or null');
         toast.error("Va rugam sa incercati din nou.");
         return false;
      }
      const allData = { opportunityId: stepsState.opportunityId, ...values };
      const ENDPOINT = tipCetatenie === "ROMAN" ? process.env.REACT_APP_API_ENDPOINT_B2C_PAS5 : process.env.REACT_APP_API_ENDPOINT_B2C_PAS5_STRAIN;
      const postObject =
         tipCetatenie === "ROMAN"
            ? {
                 data: prepareDataStep5(allData),
                 headers: [{ name: "Content-Type", value: "multipart/form-data" }],
              }
            : { data: await prepareDataStep5_STRAIN(allData) };

      const response = await requestJson(ENDPOINT, RequestMethod.POST, postObject);

      if (!response.isSuccess) {
         const ERROR_MESSAGE =
            tipCetatenie === "ROMAN"
               ? "Nu s-a putut citi corect CI-ul. Vă rugăm să încercați din nou cu o altă poză."
               : "Eroare la salvarea datelor. Va rugam sa incercati din nou.";
         toast.error(ERROR_MESSAGE);
         clearProgressBar();
         setShowProgressBar(false);
         return;
      }

      if (tipCetatenie === "STRAIN") {
         persistState(prevState => {
            return {
               ...prevState,
               step5: {
                  ...prevState.step5,
                  fileNIF: values.fileNIF, //Cetatean_STRAIN
                  filePermisSedere: values.filePermisSedere, //Cetatean_STRAIN
                  filePasaport: values.filePasaport, //Cetatean_STRAIN
                  fileAlteDocumente: values.fileAlteDocumente, //Cetatean_STRAIN
               },
            };
         });
      } else {
         if (response.response.predictionOutput.layoutConfidenceScore > 0.5) {
            persistState(prevState => {
               return {
                  ...prevState,
                  step5: {
                     ...prevState.step5,
                     fileCI: values.fileCI, //Cetatean_ROMAN
                  },
                  step6: {
                     ...prevState.step6,
                     nume: response.response.predictionOutput.labels?.Nume?.value,
                     prenume: response.response.predictionOutput.labels?.Prenume?.value,
                     serieCI: response.response.predictionOutput.labels?.Serie?.value,
                     numarCI: response.response.predictionOutput.labels?.Numar?.value,
                     emisDeCI: response.response.predictionOutput.labels?.Emitent?.value,
                     emisLaCI: response.response.predictionOutput.labels?.Valabilitate?.value.substring(0, 8),
                     expiraLaCI:
                        response.response.predictionOutput.labels?.Valabilitate?.value.substring(9, 15) +
                        response.response.predictionOutput.labels?.Valabilitate?.value.substring(17, 19),
                     cnp: response.response.predictionOutput.labels?.CNP?.value,
                  },
               };
            });
         } else {
            toast.error("Nu s-a putut citi corect CI-ul. Vă rugăm să încercați din nou cu o altă poză.");
            clearProgressBar();
            setShowProgressBar(false);
            return;
         }
      }
      window.dataLayer.push({ event: "pas_5_casnici", info: { pagina: "step-5", finalizat: "da" } });
      setCurrentStep(currentStep + 1);
      localStorage.setItem("sessionCurrentStep", currentStep + 1);

      clearProgressBar();
      setShowProgressBar(false);
   };

   const clearProgressBar = () => {
      setProgress(5);
   };

   const startProgressBar = () => {
      clearProgressBar();
      const interval = setInterval(() => {
         setProgress(prevProgress => {
            if (prevProgress >= 100) {
               clearInterval(interval);
               return 95;
            } else {
               return prevProgress + 10;
            }
         });
      }, 4000);
   };

   useEffect(() => {
      refToErrorFormik(formik);
   }, [formik]);

   return (
      <section className="mt-80 mb-80">
         <div className="container">
            <div className="row">
               <div className="col-md-8 ml-auto mr-auto">
                  <div className="pas-5">
                     <h2 className="first_title">Datele tale de identificare</h2>
                     {showProgressBar ? (
                        <div className="pb-50">
                           <p className="text-center">În acest moment se procesează datele tale de identificare. Te rugăm să aștepți.</p>
                           <ProgressBar animated min={0} max={100} now={progress} />
                        </div>
                     ) : (
                        <>
                           <p className="text-center">
                              Te rugăm să alegi una din opțiunile de mai jos pentru a fotografia sau încărca o imagine {headerText} de identitate.
                           </p>
                           <form onSubmit={formik.handleSubmit}>
                              {tipCetatenie === "ROMAN" ? (
                                 <Step5CetatenieRoman
                                    setFieldValue={formik.setFieldValue}
                                    formikValues={formik.values}
                                    formikErrors={formik.errors}
                                    formikTouched={formik.touched}
                                 />
                              ) : (
                                 <Step5CetatenieStrain
                                    setFieldValue={formik.setFieldValue}
                                    formikValues={formik.values}
                                    formikErrors={formik.errors}
                                    formikTouched={formik.touched}
                                 />
                              )}
                              <NavigateButtons currentStep={currentStep} setCurrentStep={setCurrentStep} />
                           </form>
                        </>
                     )}
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}
